import { render, staticRenderFns } from "./obnalichka.vue?vue&type=template&id=44b5ba7e&scoped=true&"
import script from "./obnalichka.vue?vue&type=script&lang=js&"
export * from "./obnalichka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5ba7e",
  null
  
)

export default component.exports